module.exports = __webpack_public_path__ + "static/cruise-8e75ffef7fae09dfe25089b32827d795.jpg";